require("!!/var/www/html/scora.io/frontend/scorauser/node_modules/script-loader/addScript.js")(require("!!/var/www/html/scora.io/frontend/scorauser/node_modules/raw-loader/index.js!/var/www/html/scora.io/frontend/scorauser/node_modules/chart.js/dist/Chart.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.min.js
// module id = 595
// module chunks = 8